/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import InputSmallLabel from 'DesignSystem/InputSmallLabel/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Comms/Phones/AddPhoneNumber/Content/Name",
  onChange,
  isInvalid
  
}) {
let phoneNumberNameValueData = fromData.useDataValue({ viewPath,
context: 'phone_number',
path: 'name',
})
let phoneNumberNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'phone_number',
path: 'name',
validate: fromValidate.textInput,
required: true,
})
let phoneNumberNameChangeData = fromData.useDataChange({ viewPath,
context: 'phone_number',
path: 'name',
})
  return (<React.Fragment
>
<InputSmallLabel
  viewPath={`${viewPath}/InputSmallLabel`}
 label="Phone name"
 marginRight={16}
 width={170}
 data="phone_number.name"
 validate="/Data/validate.js textInput"
 required={true}
 onChange={phoneNumberNameChangeData}
 value={phoneNumberNameValueData}
 isInvalid={!phoneNumberNameIsValidData}
/>
{children}
</React.Fragment>)
}